import React, {ComponentProps} from "react";
import * as api from "../../apis/sampleDealerQuota";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Space} from "antd";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import {PlatformType} from "../../utils/constants";


function SampleDealerQuota(props: ComponentProps<any>) {
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform ?? PlatformType.Dealer;
    const {tableProps, search, form, refresh} = useAntTable(api.getDealerQuotas, {});

    const columns: StandardColumnsType = [
        {
            dataIndex: 'dealerName',
            title: '客户名称',
            search: platform == PlatformType.Admin
        },
        {
            dataIndex: 'amount',
            title: '样品额度'
        },
        {
            dataIndex: 'operation',
            title: '操作',
            render(v, r: any) {
                return <Space>
                    <Link to={`/sample/dealerQuota/detail/${r.dealerId}`}>交易记录</Link>
                </Space>
            }
        }
    ];


    return <PageHeaderLayout>
        <StandardTable {...tableProps} submit={search.submit} columns={columns} search={search} form={form}/>
    </PageHeaderLayout>
}


export default SampleDealerQuota;
